<template>
	<div class="leftsidebar" :class="{'leftsidebar--open': this.$store.state.app.sidebars.left}">
		<div @click="toggleLeftSidebar" class="puller leftsidebar__puller">
			<span
				class="puller_icon leftsidebar__puller__icon"
				:class="{'leftsidebar__puller__icon--closed': this.$store.state.app.sidebars.left}"
			></span>
			KROK {{ currentStep }}/10
		</div>

		<div ref="scrollable" class="leftsidebar__scrollable">
			<ul>
				<li
					class="leftsidebar__link"
					:class="[
						isModelDropdownOpen ? 'leftsidebar__link--active' : 'leftsidebar__link--visited',
					]"
				>
					<router-link :to="{name: 'model'}">
						<p class="leftsidebar__model" :class="{'leftsidebar--active': 'model' === $route.name}">
							Model
							<span
								class="leftsidebar__model__arrow"
								:class="[
									isModelDropdownOpen
										? 'leftsidebar__model__arrow--up'
										: 'leftsidebar__model__arrow--down',
								]"
							></span>
						</p>
					</router-link>
					<ul :class="{hidden: !isModelDropdownOpen}">
						<LeftSidebarModelLink
							v-for="unit in appData.unitsList"
							:key="unit.name"
							:name="unit.name"
							:text="unit.fullName"
							:active="unit.name === currentlyVisibleModelName"
						/>
					</ul>
				</li>

				<li
					v-for="step in steps"
					class="leftsidebar__link"
					:key="step.name"
					:class="stepClassName(step.name)"
				>
					<router-link :to="{name: step.name}">
						<p
							:class="{
								'leftsidebar--active': step.name === $route.name,
								'leftsidebar--hidden': leftSidebarHidden,
							}"
						>
							{{ step.title }}
						</p>
					</router-link>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import * as R from 'ramda';
import LeftSidebarModelLink from './LeftSidebarModelLink';
import wizardSteps from '../data/wizard-steps.json';
import AppDataMixin from '@/mixins/app-data';
import WindowScrollMixin from '@/mixins/window-scroll';

let wizardStepsNames = R.map(step => step.name, wizardSteps);

function getStepId(route_name) {
	// +2 to account for 0-based indexes and hardcoded 'model' step
	if (route_name !== 'model') return R.indexOf(route_name, wizardStepsNames) + 2;

	// 'model' is hardcoded, not in wizardSteps, return static value
	return 1;
}

export default {
	name: 'LeftSidebar',
	components: {
		LeftSidebarModelLink,
	},
	mixins: [AppDataMixin, WindowScrollMixin],
	data() {
		return {
			steps: wizardSteps,
		};
	},
	computed: {
		isModelDropdownOpen() {
			return this.$route.name === 'model';
		},
		currentlyVisibleModelName() {
			return this.$route.params.name;
		},
		showCover() {
			return this.$store.state.app.sidebars.right;
		},
		leftSidebarHidden() {
			return !this.$store.state.app.sidebars.left;
		},
		currentStep() {
			return getStepId(this.$route.name);
		},
	},
	methods: {
		handleWindowScroll(dy) {
			this.$refs.scrollable.scrollTop = this.$refs.scrollable.scrollTop + dy;
		},
		stepClassName(step_name) {
			let class_name = 'leftsidebar__link--active';

			let step_id = getStepId(step_name);
			let route_id = getStepId(this.$route.name);

			if (step_id < route_id) class_name = 'leftsidebar__link--visited';
			else if (step_id > route_id) class_name = 'leftsidebar__link--inactive';

			return class_name;
		},
		toggleLeftSidebar() {
			const sidebars = {
				left: !this.$store.state.app.sidebars.left,
			};
			// on phones allow only one sidebar open
			if (this.$store.state.app.media === 'phone') sidebars.right = false;

			this.$store.commit('M_SET_APP_STATE', {sidebars});
		},
	},
};
</script>
